import { render } from "./RequestToPollPage.vue?vue&type=template&id=31666def"
import script from "./RequestToPollPage.vue?vue&type=script&lang=js"
export * from "./RequestToPollPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__